// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */
// 地图
import map from '@/views/map/map';
import fieldManage from "@/views/fieldManage";
import message from "@/views/message";

// 启用路由
Vue.use(Router);

// 导出路由 
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        },
        default: true
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [{
            path: '/map/map',
            name: '地图',
            component: map,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/fieldManage',
            name: '地块管理',
            component: fieldManage,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/message',
            name: '通知消息',
            component: message,
            meta: {
                requireAuth: true
            }
        },
        ]
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js